export default {
  winnfTs0122: "Cybersecurity",
  battery: "Battery",
  dhr: "Device Hardware Reliability"
};
